import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import NavbarComponent from './Navbar';
import Footer from './Footer';

function LegalPage({ title, effectiveDate, children }) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} | John West`;
    window.scrollTo(0, 0);
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <div className="legal-page">
      <NavbarComponent />
      <header className="legal-header">
        <Container>
          <div className="section-divider" style={{ background: 'linear-gradient(135deg, var(--accent), #ff6b6b)' }}></div>
          <h1 className="legal-title">{title}</h1>
          <p className="legal-date">Effective {effectiveDate}</p>
        </Container>
      </header>
      <main className="legal-body">
        <Container>
          <div className="legal-content">{children}</div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}

export default LegalPage;
